import { Text } from '../../../ui/primitives/Text.tsx';
import { VisuallyHidden } from '../../../ui/primitives/VisuallyHidden.tsx';
import { useCountUp } from '../../../ui/primitives/useCountUp.ts';
import styles from './shared.module.css';

const NUMBER = new Intl.NumberFormat('pt-BR');

export type CountedVariant = 'display-xl' | 'numeric-display' | 'token-lg';

/**
 * A real figure, counted up to.
 *
 * `tone` exists for exactly one caller at a time: § 5.3 allows the gradient
 * treatment on ONE phrase per screen, and on a Profile the phrase worth
 * spending it on is a number. It is passed through rather than decided here,
 * because this component cannot know whether the screen has already spent it.
 */
export function Counted({
  value,
  variant,
  tone,
}: {
  value: number;
  variant: CountedVariant;
  tone?: 'gradient';
}) {
  const shown = useCountUp(value);

  return (
    <span className={styles.counted}>
      <Text as="span" variant={variant} tone={tone}>
        {NUMBER.format(shown)}
      </Text>
      <VisuallyHidden>{NUMBER.format(value)}</VisuallyHidden>
    </span>
  );
}
